import type { ThemeCEFRLevel, ThemeCharacterCard } from '@/api/services/themes'

// 后台主题接口返回的主题对象（字段沿用旧版页面实际读取的部分）
export interface Theme {
  id: number
  code: string
  title: string
  description?: string | null
  category: string
  cefr_level?: ThemeCEFRLevel
  locale: string
  is_active: boolean
  version: number
  created_at: string
  updated_at?: string
  initial_fixed_setting?: Record<string, unknown> | string | null
  initial_recap?: string | null
  first_episode_title?: string | null
  first_episode_story_text?: string | null
  style_hints?: Record<string, unknown> | string | null
  theme_specific_prompt?: string | null
  cover_image_url?: string | null
  list_hook?: string | null
  character_cards?: ThemeCharacterCard[] | null
  tags?: string[] | null
  themes_info?: { tags?: unknown[] } | null
}

export interface ThemeUsageStats {
  total_instances: number
  active_instances: number
  total_episodes: number
  avg_episodes_per_instance: number
}

export interface ThemeListFilters {
  category?: string
  locale?: string
  is_active?: boolean
}

// 标签存放在 tags 或 themes_info.tags
export function themeTags(theme: Theme | null | undefined): string[] {
  const source = Array.isArray(theme?.tags) ? theme.tags : theme?.themes_info?.tags
  return Array.isArray(source) ? source.filter((tag): tag is string => typeof tag === 'string') : []
}
